// extracted by mini-css-extract-plugin
module.exports = {"navHeader":"styles_navHeader__37Btz","fullWidth":"styles_fullWidth__2BiFp"};